"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-AuthComponent__container',
    card: 'c-AuthComponent__Card',
    button: 'c-AuthComponent__action',
    padding: 'c-AuthComponent__spacing',
    centered: 'c-AuthComponent__centered',
    link: 'c-AuthComponent__link',
    text: 'c-AuthComponent__text',
    textInner: 'c-AuthComponent__textInner',
};
exports.Style = {
    [exports.CSS.padding]: {
        paddingTop: theme_1.DefaultTheme.space(6),
    },
    [exports.CSS.button]: {
        width: '100%',
        backgroundColor: theme_palette_1.ColorPalette2022Branding.darkGray,
        color: theme_1.DefaultTheme.background.offWhite,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    [`${exports.CSS.button}:hover`]: {
        backgroundColor: theme_palette_1.ColorPalette2022Branding.g3,
    },
    [exports.CSS.container]: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '14px',
    },
    [exports.CSS.centered]: {
        transform: 'translateX(50vw) translateY(50vh)',
        marginLeft: '-12px',
        marginTop: '-12px',
    },
    [exports.CSS.link]: {
        color: theme_palette_1.ColorPalette2022Branding.lightBlue,
        fontSize: '14px',
    },
    [`${exports.CSS.link}:hover`]: {
        textDecoration: 'underline',
    },
    [exports.CSS.text]: {
        color: theme_palette_1.ColorPalette2022Branding.g6,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '14px',
        borderTop: `1px solid ${theme_palette_1.ColorPalette2022Branding.g6}`,
    },
    [exports.CSS.textInner]: {
        background: theme_1.DefaultTheme.background.offWhite,
        margin: 'auto',
        transform: 'translateY(-50%)',
        display: 'inline-block',
        padding: theme_1.DefaultTheme.space(1),
    },
};
//# sourceMappingURL=auth.component.style.js.map